/* Copyright (c) 2025 MOCA Systems, Inc.  All rights reserved. */
import { Component } from '@appCanvasCommon/component-system/Component';
import { ComponentInterface } from '@appCanvasCommon/interfaces/component.interface';
import { CanvasAngularLand } from '../../../../app-data/interfaces/canvas-angular-land';
import { AbstractApplication } from '@appCanvasCommon/core/AbstractApplication';
import { IExportContext } from '@appCanvasCommon/export/IExportContext';
import { TicketPlanApplication } from '@appPlanApplication/TicketPlanApplication';
import { ActiveLineDrawer } from '@appPlanApplication/timeline/active-line/ActiveLineDrawer';
/**
 * This export component hides the root active line node when the capture is printing the 2nd row and beyond
 * Otherwise the active line would be copied vertically as the camera scans the plan area.
 */
export class HideActiveLineLabel extends Component implements ComponentInterface {
	/**
	 * Invoked for each tile captured.
	 * @param canvasAngularLand
	 * @param application
	 * @param context
	 */
	public onExportTile(
		canvasAngularLand: CanvasAngularLand,
		application: AbstractApplication,
		context: IExportContext
	): void {
		if (context.isFirstRow) {
			return;
		}

		const app: TicketPlanApplication = application as TicketPlanApplication;
		const line: ActiveLineDrawer = app?.timeline?.activeLine;
		if (line) {
			line.hideLabel();
		}
	}
	/**
	 * Invoked once the export is finished. This turns the milestone line back on.
	 * @param canvasAngularLand
	 * @param application
	 */
	public onExportComplete(canvasAngularLand: CanvasAngularLand, application: AbstractApplication): void {
		const app: TicketPlanApplication = application as TicketPlanApplication;
		const line: ActiveLineDrawer = app?.timeline?.activeLine;
		if (line) {
			line.showLabel();
		}
	}
}
